module.exports = __webpack_public_path__ + "img/clean.64d48271.svg";